import { Row, Col, Typography } from "antd";
import { ProjectSettingApi } from "@/entities/api/project/types";
import { SettingsCardItem } from "../settings-card-item/settings-card-item";
import { SettingsSkeletonList } from "../settings-sceleton-list";
import "./settings-card-block.scss";

interface ISettingsCardBlock {
  blockTitle: string;
  settingsList?: ProjectSettingApi.IntegrationSetting[];
  isLoading?: boolean;
}

export const SettingsCardBlock = ({
  blockTitle,
  settingsList,
  isLoading,
}: ISettingsCardBlock) => {
  return (
    <>
      {isLoading ? (
        <SettingsSkeletonList />
      ) : (
        <>
          {settingsList?.length && settingsList.length > 0 ? (
            <div className="project-setting-container">
              <div className="project-setting-header">
                <h2 className="project-setting-title">{blockTitle}</h2>
                {/* {isAdd ? (
                  <Can I="access" a="project">
                    <a
                      href={oldBuilddocsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Редактировать
                    </a>
                  </Can>
                ) : null} */}
                {/* <Can I="access" a="project">
                 <a
                    href={oldBuilddocsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Редактировать
                  </a> 

                </Can> */}
              </div>
              <Row gutter={[16, 16]}>
                {settingsList.map((card) => (
                  <Col
                    key={card.integrationId}
                    xs={24}
                    sm={12}
                    md={8}
                    className="project-setting-card-col"
                  >
                    <SettingsCardItem settingsInfo={card} />
                  </Col>
                ))}
              </Row>
            </div>
          ) : (
            <div className="settings-card-block-empty">
              <Typography.Title level={3} style={{ color: "#888" }}>
                Нет данных
              </Typography.Title>
              {/* <Can I="access" a="project"> */}
              {/* <a
                href={oldBuilddocsUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Редактировать
              </a> */}
              {/* </Can> */}
            </div>
          )}
        </>
      )}
    </>
  );
};
